export function buildLibraryBreadcrumbs({
    category,
    categoryId,
    selectedTaskId,
    task,
    categoryTrail,
    directories = [],
} = {}) {
    const list = [{ id: "components", name: "Library", isHome: true }]

    if (categoryTrail) {
        list.push(...categoryTrail)
    } else if (category?.path) {
        const directoriesByPath = buildDirectoriesByPath(directories)
        let currentPath = ""
        for (const part of category.path.split("/")) {
            currentPath = currentPath ? `${currentPath}/${part}` : part
            const directory = directoriesByPath.get(currentPath)
            if (directory && !isLibraryRootPath(currentPath)) {
                list.push({ id: directory.id, name: directory.name })
            }
        }
    }

    if (!categoryTrail && categoryId && !isLibraryRootId(categoryId) && category && !list.some(isCurrentCategory)) {
        list.push({ id: categoryId, name: category.name || "Folder" })
    }

    if (selectedTaskId === "new") {
        list.push({ id: "new", name: "New Component" })
    } else if (selectedTaskId && task) {
        list.push({ id: selectedTaskId, name: task.heading })
    }

    return list

    function isCurrentCategory(crumb) {
        return crumb.id === categoryId
    }
}

function buildDirectoriesByPath(directories) {
    const directoriesByPath = new Map()
    for (const directory of directories) {
        if (directory?.path) directoriesByPath.set(directory.path, directory)
    }
    return directoriesByPath
}

function isLibraryRootPath(path) {
    return path?.toLowerCase() === "components"
}

function isLibraryRootId(id) {
    return id?.toLowerCase() === "components"
}
